import type { ModalType } from '../types/ModalType';

/**
 * Module-scoped store for the app's single active modal, replacing the former Apollo
 * `activeModalVariable` reactive var. Components subscribe reactively through `useModal`
 * (`useSyncExternalStore`); non-React callers (e.g. uploaderUtils) read or write
 * imperatively via these helpers. `null` means no modal is open.
 */
let activeModal: ModalType | null = null;
const listeners = new Set<() => void>();

export const modalStore = {
  getActiveModal: (): ModalType | null => activeModal,
  setActiveModal: (modal: ModalType | null): void => {
    // Skip the broadcast when the value is unchanged, matching makeVar's equality check
    // and keeping the useSyncExternalStore snapshot stable.
    if (modal === activeModal) {
      return;
    }
    activeModal = modal;
    listeners.forEach((listener) => listener());
  },
  subscribe: (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
